module.exports = __webpack_public_path__ + "img/4.875420d7.png";